import { Box, Divider, Stack, styled } from '@mui/material';

export const SiteImage = styled(Stack)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 150px;
`;

export const LoginBackground = styled(Stack)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`;

export const ListDivider = styled(Divider)`
  width: 90%;
  margin: auto;
`;

export const MapListImage = styled(Box)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 124px;
  height: 124px;
  border-radius: 10px;
`;

export const FormDivider = styled(Divider)`
  border: 1px solid #5546a9;
`;

export const SelectImage = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #f5f7fe;
  border-radius: 18px;
  color: #5546a9;
  font-size: 18px;
  font-weight: 500;
  line-height: 100%;
  cursor: pointer;
`;

export const AttachmentArea = styled(Stack)`
  border-radius: 10px;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 6px 18px;
  width: 100%;
  min-height: 52px;
`;

export const CommonDivider = styled(Divider)`
  border: 1px solid #e6e0e9;
`;

export const TableBackground = styled(Stack)`
  border-radius: 20px;
  background: #f5f7fe;
  width: 100%;
  height: 100%;
  flex: 1;
  padding: 30px 40px;
`;

export const EmptyBackground = styled(Stack)`
  border-radius: 20px;
  border: 1px solid #f5f7fe;
  width: 100%;
  height: 100%;
  flex: 1;
  padding: 30px 40px;
`;

export const Attachment = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
